module.exports = __webpack_public_path__ + "static/california-state-parks-8d8f2f2871dde59dab51b4878972f7f7.png";